import React, { FormEvent, useEffect, useState } from "react";
import { subscribeToNewsletter } from "../../utils/subscribeToNewsletter"

const useNewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [isSuccessfullySent, setIsSuccessfullySent] = useState(false);

  useEffect(() => {
    if (!isSuccessfullySent) return;

    setTimeout(() => {
      setIsSuccessfullySent(false);
    }, 5000);
  }, [isSuccessfullySent]);

  const isEmailVaild = () => {
    const REGEX =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const isValid = email.match(REGEX);
    if (!isValid) {
      setError("Email has invalid format");
    } else {
      setError("");
    }
    return isValid;
  };

  const updateEmail = (email: string) => {
    if (error) {
      setError("");
    }
    setEmail(email);
  };

  const signToNewsletter = async (event: FormEvent) => {
    event.preventDefault();

    if (!isEmailVaild()) {
      return;
    }

    try {
      setSending(true);
      const result = await subscribeToNewsletter(email);

      if (result.message) {
        setSending(false);
        setError(result.message);
        return;
      }

      if (result.errors) {
        setSending(false);
        setError(
          result.errors.reduce(
            (previousValue: string, currentValue: string) =>
              previousValue + " " + currentValue,
            ""
          )
        );
      }

      setIsSuccessfullySent(true);
      setEmail("");
    } catch (error) {
      // @ts-ignore
      setError(error.message);
    } finally {
      setSending(false);
    }
  };

  return {
    isSuccessfullySent,
    email,
    error,
    isEmailVaild,
    sending,
    updateEmail,
    signToNewsletter,
  };
};

export default useNewsletterForm
